import cookies from 'js-cookie';

import { AUTH0_AUDIENCE, COOKIE_DOMAIN } from '../config';
import cookieNames from '../constants/cookieNames';
import createAuth0Client from '../services/auth0';
import fallbackTokenPayload from './fallbackTokenPayload';
import getExpFromToken from './getExpFromToken';

const getTokens = () => {
  const cookieData = fallbackTokenPayload();
  const auth0Client = createAuth0Client();

  if (!cookieData) {
    return auth0Client
      .then((client) =>
        client.getTokenSilently({
          authorizationParams: {
            audience: AUTH0_AUDIENCE,
            timeoutInSeconds: 5,
          },
        })
      )
      .then((accessToken) => {
        cookies.set(cookieNames.accessToken, accessToken, {
          expires: getExpFromToken(accessToken),
          domain: COOKIE_DOMAIN,
        });
        return Promise.resolve(fallbackTokenPayload());
      });
  }
  return Promise.resolve(cookieData);
};

export default getTokens;
